export const genericModalI18NPl = {
    cancel: "Anuluj",
    ok: "OK",
    reset: "Resetuj",
};
